// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see MarketingFooterClickLinkEvent
 */
export var MarketingFooterClickLink = function (_a) {
    var href = _a.href, elementParentIdentifier = _a.elementParentIdentifier, elementIdentifier = _a.elementIdentifier, elementText = _a.elementText, elementType = _a.elementType, elementTitle = _a.elementTitle;
    return ({
        name: "MarketingFooter Click Link",
        parameters: {
            cdf_entity: "MarketingFooter",
            cdf_action: "Click",
            href: href !== undefined && href !== null ? href.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            element_parent_identifier: elementParentIdentifier !== undefined && elementParentIdentifier !== null ? elementParentIdentifier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            element_identifier: elementIdentifier !== undefined && elementIdentifier !== null ? elementIdentifier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            element_text: elementText !== undefined && elementText !== null ? elementText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            element_type: elementType !== undefined && elementType !== null ? elementType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            element_title: elementTitle !== undefined && elementTitle !== null ? elementTitle.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
